import { render } from "./ProgramTerminationReport.vue?vue&type=template&id=218ebca5&ts=true"
import script from "./ProgramTerminationReport.vue?vue&type=script&lang=ts"
export * from "./ProgramTerminationReport.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__